import { LogoutButton } from '@pages/auth';
import { CallsContainer } from '@pages/calls/CallsContainer';
import { CasesContainer, CreateCase } from '@pages/cases';
import { ChatContainer } from '@pages/chat';
import {
  BadgeCheck,
  BarChart3,
  Briefcase,
  ClipboardList,
  FileSpreadsheet,
  Folder,
  LayoutGrid,
  ListTodo,
  Mail,
  MessageSquare,
  Phone,
  ShieldCheck,
} from 'lucide-react';
import type { ComponentType } from 'react';

import { AllTasksContainer } from '@/pages/all-tasks';
import { AnalyticsContainer } from '@/pages/analytics';
import { CampaignsContainer } from '@/pages/campaigns/CampaignsContainer';
import { CasesAnalyticsContainer } from '@/pages/cases-analytics';
import { MailboxContainer } from '@/pages/mailbox';
import { MyCasesContainer } from '@/pages/my-cases';
import { MyTasksContainer } from '@/pages/my-tasks';
import { QcContainer } from '@/pages/qc';
import { WorkforceContainer } from '@/pages/workforce';

const authProtectedRoutes: RoutePathType[] = [
  {
    title: 'Cases',
    path: '/cases',
    component: CasesContainer,
    pathCategory: '/cases',
    icon: Folder,
    solidIcon: Folder,
    showInSidebar: true,
  },
  {
    // Org-scoped; directly below Cases in the sidebar (AuthSidebar keeps route order).
    title: 'All Tasks',
    path: '/all-tasks',
    component: AllTasksContainer,
    pathCategory: '/all-tasks',
    icon: ClipboardList,
    solidIcon: ClipboardList,
    showInSidebar: true,
  },
  {
    title: 'My Calls',
    path: '/calls',
    component: CallsContainer,
    icon: Phone,
    solidIcon: Phone,
    showInSidebar: true,
    pathCategory: '/calls',
  },
  {
    title: 'Create Case',
    path: '/create-case',
    component: CreateCase,
    pathCategory: '/create-case',
    icon: Phone,
    solidIcon: Phone,
    showInSidebar: false,
  },
  {
    title: 'Logout',
    path: '/logout',
    component: LogoutButton,
    pathCategory: '/logout',
    showInSidebar: false,
  },
  {
    title: 'Campaigns',
    path: '/campaigns',
    component: CampaignsContainer,
    icon: FileSpreadsheet,
    solidIcon: FileSpreadsheet,
    showInSidebar: true,
    pathCategory: '/campaigns',
  },
  {
    title: 'QC Analytics',
    path: '/analytics',
    component: AnalyticsContainer,
    pathCategory: '/analytics',
    icon: BarChart3,
    solidIcon: BarChart3,
    showInSidebar: true,
  },
  {
    title: 'AE / PQC Analytics',
    path: '/cases-analytics',
    component: CasesAnalyticsContainer,
    pathCategory: '/cases-analytics',
    icon: ShieldCheck,
    solidIcon: ShieldCheck,
    showInSidebar: true,
  },
  {
    title: 'Call Evaluations',
    path: '/qc',
    component: QcContainer,
    pathCategory: '/qc',
    icon: BadgeCheck,
    solidIcon: BadgeCheck,
    showInSidebar: true,
  },
  {
    title: 'Notifications',
    path: '/mailbox',
    component: MailboxContainer,
    pathCategory: '/mailbox',
    icon: Mail,
    solidIcon: Mail,
    showInSidebar: false,
  },
  {
    title: 'AI Chat',
    path: '/chat',
    component: ChatContainer,
    pathCategory: '/chat',
    icon: MessageSquare,
    solidIcon: MessageSquare,
    showInSidebar: true,
  },
  {
    title: 'Workforce Console',
    path: '/workforce',
    component: WorkforceContainer,
    pathCategory: '/workforce',
    icon: LayoutGrid,
    solidIcon: LayoutGrid,
    showInSidebar: true,
  },
  {
    title: 'My Tasks',
    path: '/my-tasks',
    component: MyTasksContainer,
    pathCategory: '/my-tasks',
    icon: ListTodo,
    solidIcon: ListTodo,
    showInSidebar: true,
  },
  {
    title: 'My Cases',
    path: '/my-cases',
    component: MyCasesContainer,
    pathCategory: '/my-cases',
    icon: Briefcase,
    solidIcon: Briefcase,
    showInSidebar: true,
  },
];

export type RoutePathType = {
  title?: string;
  path: string;
  component: ComponentType;
  icon?: ComponentType;
  showInSidebar: boolean;
  solidIcon?: ComponentType;
  pathCategory: string;
  noSidebar?: boolean;
};

export { authProtectedRoutes };
